/**
 * Route Google Places / Google Photos image URLs through the
 * images.weserv.nl proxy at render time.
 *
 * Google's `lh3.googleusercontent.com` URLs rotate/expire on Google's
 * side (their photo_reference tokens are short-lived). Directly
 * embedding those URLs in <img src=""> produces routine 404s in the
 * browser once the token rotates — which our onError handlers were
 * catching + console.error'ing, flooding Sentry with 100+ events per
 * week from ONE landing page load (issue: google-places-image-404).
 *
 * The proxy fetches the image once, caches it durably, and serves a
 * stable URL, so the browser never sees the transient 404.
 *
 * If the URL is not from Google, returns it unchanged — customers can
 * upload their own logos + cover photos and those go through as-is.
 *
 * If the URL is falsy or malformed, returns it unchanged.
 */
export function proxyGoogleImage(
  url: string | null | undefined,
  width: number,
): string {
  if (!url) return '';
  if (!url.includes('googleusercontent.com')) return url;
  return `https://images.weserv.nl/?url=${encodeURIComponent(url)}&w=${width}`;
}
